<template>
  <div class="h-full">
    <div class="flex flex-col items-center justify-center flex-1 h-full bg-gray-50">
      <IconAddCircleOutline
        v-if="!isAddNewHidden"
        class="m-2 text-blue-500 cursor-pointer w-17 h-17"
        @click="emit('addNew')" />
      <span class="text-sm text-gray-500 pointer-events-none">{{
        $t('messages.info.emptyTableText')
      }}</span>
      <span v-if="!isAddNewHidden" class="text-xs text-gray-500 pointer-events-none"
        >{{ $t('messages.info.addDataTableText') }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import IconAddCircleOutline from '@/assets/icons/IconAddCircleOutline.vue';

defineProps<{
  isAddNewHidden?: boolean;
}>();

const emit = defineEmits(['addNew']);
</script>
